<template>
  <div class="loginPage">
		<div class="loginComponent" style="width: 80%">
			<h1>
	ASA24 Researcher Site Accessibility Policy
</h1>
<div class="text-h6 text-left">
	The ASA24 Researcher Web site was designed to be accessible to all users and compatible with screen readers and other assistive technologies. However, accessibility is an ongoing process. Therefore, it is possible that you could encounter problems when accessing certain pages. If you would like to report a problem or obtain help accessing information on any ASA24 Researcher Web site page, please complete and submit the Accessibility Feedback Form below.
</div>
<br>
<div class="text-h6 text-left">
	Please include the operating system of the computer you are using, the type and version of the device (e.g. PC or Mac), and title or URL of the page you are having difficulty accessing.
</div>
<a class="text-left text-decoration-underline" @click="$router.push('/accessibility/form')" @keyup.enter="$router.push('/accessibility/form')" tabindex="0">Accessibility Feedback Form</a>
		</div>
  </div>
</template>

<script>

export default {
	name: 'AccessibilityInfo',
	metaInfo: {
		title: 'Accessibility Info'
	}
}
</script>
<style>
</style>
